import { TextProps } from "../../types/textTypes";
import "./h2.scss";

const H2: React.FC<TextProps> = ({ children, className }) => {
  return <h2 className={`h2 ${className ? className : ""}`}>{children}</h2>;
};

export default H2;
